import {
  MdOutlineDashboard,
  MdPersonAddAlt,
  MdSearch,
  MdAddCircleOutline,
  MdNotificationsNone,
  MdOutlineMail,
  MdTrendingUp,
  MdInsertChartOutlined,
  MdRocketLaunch,
  MdOutlineCalendarToday,
  MdOutlineInfo,
  MdOutlineAccessTime,
  MdOutlinePerson,
  MdOutlineSecurity,
  MdOutlineVpnKey,
  MdOutlineSettings,
  MdOutlineManageAccounts,
  MdOutlineAutoAwesome,
  MdMenu,
  MdClose,
  MdOutlineSmartphone,
  MdSignalCellularAlt,
  MdRouter,
  MdCheckCircle,
  MdCheck,
  MdArrowBack,
  MdKeyboardArrowRight,
  MdOutlineCheckCircleOutline,
  MdCheckCircleOutline,
  MdOutlineCable,
  MdOutlineCellTower,
  MdOutlinePlace,
  MdOutlinePictureAsPdf,
  MdOutlineAdd,
  MdOutlineShoppingCart,
  MdKeyboardArrowDown,
  MdOutlineFolderOpen,
  MdOutlineDescription,
  MdOutlinePeople,
  MdOutlineUpload,
  MdStarOutline,
  MdOutlineBusiness,
} from "react-icons/md";
import { FcGoogle } from "react-icons/fc";
import { AiOutlineMail } from "react-icons/ai";
import {
  IoCalculatorOutline,
  IoCalendarOutline,
  IoFlashOutline,
} from "react-icons/io5";
import { BiSolidOffer } from "react-icons/bi";
import { TbContract, TbReportSearch } from "react-icons/tb";
import {
  LuMegaphone,
  LuPackage,
  LuDownload,
  LuUpload,
  LuPhone,
} from "react-icons/lu";
import { AiOutlineTeam } from "react-icons/ai";
import { GoInbox } from "react-icons/go";
import { RiContactsLine } from "react-icons/ri";
import { IoIosArrowForward } from "react-icons/io";
import { FiHelpCircle } from "react-icons/fi";
import { HiOutlineLockClosed } from "react-icons/hi";

export const DashboardIcon = MdOutlineDashboard;
export const CalculatorIcon = IoCalculatorOutline;
export const OffersIcon = BiSolidOffer;
export const TeamIcon = AiOutlineTeam;
export const ContractsIcon = TbContract;
export const CalendarIcon = IoCalendarOutline;
export const NewsIcon = LuMegaphone;
export const BundlesIcon = LuPackage;
export const InboxIcon = GoInbox;
export const ReportsIcon = TbReportSearch;
export const CustomersIcon = RiContactsLine;
// Action Icons for Dashboard
export const NewCustomerIcon = MdPersonAddAlt;
export const SearchIcon = MdSearch;
export const NewOfferIcon = MdAddCircleOutline;
export const VVLIcon = MdNotificationsNone;
// Overview Icons
export const MailIcon = MdOutlineMail;
export const PotentialIcon = MdTrendingUp;
export const BestsellerIcon = MdInsertChartOutlined;
export const RocketIcon = MdRocketLaunch;
// Settings / System Icons
export const UserIcon = MdOutlinePerson;
export const SecurityIcon = MdOutlineSecurity;
export const LicenseIcon = MdOutlineVpnKey;
export const SettingsIcon = MdOutlineSettings;
export const AdminIcon = MdOutlineManageAccounts;
export const AIIcon = MdOutlineAutoAwesome;
export const MenuIcon = MdMenu;
export const CloseIcon = MdClose;
// Additional Dashboard Icons
export const CalendarIconDetail = MdOutlineCalendarToday;
export const ForecastIcon = MdTrendingUp;
export const ActivityIcon = MdOutlineAccessTime;
export const InfoIcon = MdOutlineInfo;
export const GoogleIcon = FcGoogle;
export const OutlookIcon = AiOutlineMail;
// Calculator Icons
export const ForwardIcon = IoIosArrowForward;
export const SmartphoneIcon = MdOutlineSmartphone;
export const SignalIcon = MdSignalCellularAlt;
export const RouterIcon = MdRouter;
export const SparklesIcon = MdOutlineAutoAwesome;
export const CheckCircleIcon = MdCheckCircle;
export const CheckIcon = MdCheck;
export const ArrowBackIcon = MdArrowBack;
export const ArrowRightIcon = MdKeyboardArrowRight;
export const ArrowDownIcon = MdKeyboardArrowDown;
export const MapPinIcon = MdOutlinePlace;
export const PdfIcon = MdOutlinePictureAsPdf;
export const PlusIcon = MdOutlineAdd;
export const CartIcon = MdOutlineShoppingCart;

// Landline / Calculator Specific
export const HelpIcon = FiHelpCircle;
export const LockIcon = HiOutlineLockClosed;
export const CheckCircleOutlineIcon = MdOutlineCheckCircleOutline;
export const RouterIconFi = MdRouter;

// Technology & Plan Icons
export const CableIcon = MdOutlineCable;
export const FiberIcon = IoFlashOutline;
export const DSLIcon = MdOutlineCellTower;
export const DownloadIcon = LuDownload;
export const UploadIcon = LuUpload;
export const PhoneIcon = LuPhone;
export const VerifiedIcon = MdCheckCircleOutline;

// Offers / Folders
export const FolderIcon = MdOutlineFolderOpen;
export const DescriptionIcon = MdOutlineDescription;

// Customers
export const PeopleIcon = MdOutlinePeople;
export const ImportIcon = MdOutlineUpload;
export const StarIcon = MdStarOutline;
export const BusinessIcon = MdOutlineBusiness;
